import { useQuery } from '@tanstack/react-query';
import { getPackLifecycle } from 'services/scratcherService';
import { PackLifecycleResponse } from 'features/scratchers/types';

export function usePackLifecycle(
  storeId: string | null | undefined, 
  gameId: string | null | undefined, 
  packId: string | null | undefined
) {
  return useQuery<PackLifecycleResponse>({
    queryKey: ['pack-lifecycle', storeId, gameId, packId],
    queryFn: () => getPackLifecycle(storeId!, gameId!, packId!),
    enabled: !!storeId && !!gameId && !!packId
  });
}

